import { useQuery } from '@tanstack/react-query';

import { Pipeline } from '@/models/Pipeline';
import { publicApi } from '@/utils/api';

const usePipelineByPipelineWorkflowId = (appSlug: string, pipelineWorkflowId: string | null) => {
  const has = !!pipelineWorkflowId;

  const query = useQuery({
    queryKey: ['pipelineByPipelineWorkflowId', pipelineWorkflowId, appSlug],

    queryFn: async () => {
      const {
        data: { id, name, numberInAppScope },
      } = await publicApi.get<Pipeline>(`/v0.1/apps/${appSlug}/pipelines/by-workflow-id/${pipelineWorkflowId}`);

      return {
        id,
        name,
        numberInAppScope,
      };
    },

    enabled: has,
    retry: false,
    staleTime: Infinity,
  });

  return {
    has,
    isLoading: query.isLoading,
    isError: query.isError,
    id: query.data?.id,
    name: query.data?.name,
    number: query.data?.numberInAppScope,
  };
};

export default usePipelineByPipelineWorkflowId;
